import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { hasKey } from '~/utils';

export interface VisaForeCastResponse {
  id: number;
  type: string;
  attributes: Attributes;
}

export interface Attributes {
  applicationId: string;
  model_prediction?: ModelPrediction;
}

export type ModelPrediction = Record<string, RegionScore>;

export type RegionScore = Record<string, number>;

export function useVisaProbability(id: string) {
  const request = useRequest();

  const { isLoading, isFetching, error, data, isError } = useQuery({
    queryKey: ['applicationVisaProbability', id],
    queryFn: async () => {
      const response = await request<VisaForeCastResponse>(
        `${config.apiHost}/private/v1/applications/${id}/visa_probability`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      return response;
    },
  });
  return {
    isLoadingVisaProbability: isLoading,
    isFetchingVisaProbability: isFetching,
    visaProbabilityError: error,
    visaProbability: data,
    isVisaProbabilityError: isError,
  };
}

function isExpectedResponse(res: unknown): res is VisaForeCastResponse {
  return Boolean(res && typeof res === 'object' && hasKey('attributes', res));
}
